import React from 'react';

const CtaPrimary = (props) => {
    if (props.onClick) {
        return (
            <div className='cta-btn-container' style={props.style} aria-label={props.ariaLabel} id={props.id}>
                <button className={`cta-btn primary ${props.classes || ''}`} onClick={props.onClick} style={props.buttonStyle}>
                    {props.text}
                </button>
            </div>
        );
    } else {
        return (
            <a className='cta-btn-container' href={`${props.href}`} target={props.target} style={props.style} aria-label={props.ariaLabel} id={props.id}>
                <button className={`cta-btn primary ${props.classes || ''}`}  style={props.buttonStyle}>
                    {props.text}
                </button>
            </a>
        );
    }

}

export default CtaPrimary;